/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import CourseraPlusButton from 'bundles/composable-page-header/components/coursera-plus-button/CourseraPlusButton';

const styles = {
  linkWrapper: css`
    ${breakpoints.up('md')} {
      &:hover,
      &:focus {
        /* Inherit the current dropdown item hover color */
        background-color: var(--cds-color-blue-25) !important;
        outline: none !important;
        text-decoration: none;
      }

      a {
        text-decoration: none;
      }
    }
  `,
};

const CourseraPlusButtonPopoverFooter = () => {
  return (
    <div css={styles.linkWrapper}>
      <CourseraPlusButton />
    </div>
  );
};

export default CourseraPlusButtonPopoverFooter;
